angular.module('property-deal', ['core', 'project', 'property', 'files'])
    .factory('PropertyDeal', function ($resource) {
        return $resource('/crm/api/property-deal/:id/:action', {id: "@id", action: "@action"}, {
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/property-deal/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/property-deal/table-statistics'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            statuses: {method: 'GET', url: '/crm/api/property-deal-status', isArray: true},
            action: {method: 'POST'},
            removeFile: {method: 'DELETE', url: '/crm/api/property-deal/:id/:action/attachment'},
            itemsAssets: {method: 'GET', url: '/crm/api/property-deal/:id/items-assets', isArray: true},
            addItem: {method: 'POST', url: '/crm/api/property-deal/:id/items'},
            removeItem: {method: 'DELETE', url: '/crm/api/property-deal/:id/items'},
            priceUpdate: {method: 'POST', url: '/crm/api/property-deal/:id/items/:itemId/price-change', params: {id: '@id', itemId: '@itemId'}},
            buyersUpdate: {method: 'POST', url: '/crm/api/property-deal/:id/buyers'},
            lock: {method: 'POST', url: '/crm/api/property-deal/:id/lock'},
            unlock: {method: 'POST', url: '/crm/api/property-deal/:id/unlock'},
            leadLink: {method: 'POST', url: '/crm/api/property-deal/:id/lead-link'},
            leadUnlink: {method: 'POST', url: '/crm/api/property-deal/:id/lead-unlink'},
            bankAccountUpdate: {method: 'POST', url: '/crm/api/property-deal/:id/items/:itemId/bank-account', params: {id: '@id', itemId: '@itemId'}},
            livingAreaFinalUpdate: {method: 'POST', url: '/crm/api/property-deal/:id/items/:itemId/living-area-final', params: {id: '@id', itemId: '@itemId'}},
            agreementsUpdate: {method: 'POST', url: '/crm/api/property-deal/:id/agreements'},
            lastImportantAgreement: {method: 'GET', isArray: false, url: '/crm/api/property-deal/:id/last-important-agreement'},
            agreementDelete: {method: 'DELETE', url: '/crm/api/property-deal/:id/agreements'},
            statusToggle: {method: 'POST', url: '/crm/api/property-deal/:id/status-toggle'},
            financingUpdate: {method: 'POST', url: '/crm/api/property-deal/:id/financing'},
            transfer: {method: 'GET', isArray: false, url: '/crm/api/property-deal/:id/transfer'},
            paymentSchedule: {method: 'GET', isArray: false, url: '/crm/api/property-deal/:id/payment-schedule'},
            paymentScheduleSave: {method: 'POST', isArray: false, url: '/crm/api/property-deal/:id/payment-schedule'},
            paymentScheduleDelete: {method: 'DELETE', isArray: false, url: '/crm/api/property-deal/:id/payment-schedule'},
            statisticsUpdate: {method: 'POST', isArray: false, url: '/crm/api/property-deal/:id/statistics'}
        })
    })
    .component('propertyDealLeadInfo', {
        bindings: {
            leadId: '<',
            previewStyle: '<?',
            showTitle: '<?'
        },
        template: `
            <section class="property-deal-lead-info" ng-if="$ctrl.leadId" aria-label="Informacje o leadzie">
                <div class="property-deal-lead-info__title" ng-if="$ctrl.showTitle !== false">
                    <i class="fa fa-fw fa-user-circle-o" aria-hidden="true"></i>
                    Lead
                </div>
                <div class="lead-preview-detail-list lead-preview-detail-list--compact property-deal-lead-info__details"
                     ng-if="$ctrl.previewStyle">
                    <div class="lead-preview-detail">
                        <div class="lead-preview-detail__label">Data pozyskania</div>
                        <div class="lead-preview-detail__value">
                            <strong ng-if="$ctrl.lead.acquisitionDate">{{$ctrl.lead.acquisitionDate}}</strong>
                            <span class="property-deal-lead-info__empty" ng-if="!$ctrl.loading && !$ctrl.lead.acquisitionDate">—</span>
                            <i class="fa fa-spinner fa-spin text-muted" ng-if="$ctrl.loading" aria-label="Ładowanie"></i>
                        </div>
                    </div>
                    <div class="lead-preview-detail" ng-if="$ctrl.lead.referrerClient">
                        <div class="lead-preview-detail__label">{{$ctrl.relationLabel()}}</div>
                        <div class="lead-preview-detail__value">
                            <client-finder client="$ctrl.lead.referrerClient"
                                           editable="false"
                                           template="'simple'"></client-finder>
                        </div>
                    </div>
                </div>
                <dl class="dl-horizontal property-deal-lead-info__details" ng-if="!$ctrl.previewStyle">
                    <div>
                        <dt>ID</dt>
                        <dd><a href ng-click="$ctrl.showLead()" class="bold">#{{$ctrl.leadId}}</a></dd>
                    </div>
                    <div>
                        <dt>Data pozyskania</dt>
                        <dd>
                            <strong ng-if="$ctrl.lead.acquisitionDate">{{$ctrl.lead.acquisitionDate}}</strong>
                            <span class="property-deal-lead-info__empty" ng-if="!$ctrl.loading && !$ctrl.lead.acquisitionDate">—</span>
                            <i class="fa fa-spinner fa-spin text-muted" ng-if="$ctrl.loading" aria-label="Ładowanie"></i>
                        </dd>
                    </div>
                    <div ng-if="$ctrl.lead.referrerClient">
                        <dt>{{$ctrl.relationLabel()}}</dt>
                        <dd>
                            <client-finder client="$ctrl.lead.referrerClient"
                                           editable="false"
                                           template="'simple'"></client-finder>
                        </dd>
                    </div>
                </dl>
            </section>
        `,
        controller: function (Lead, LeadService) {
            this.$onChanges = changes => {
                if (!changes.leadId || !changes.leadId.currentValue) {
                    return
                }
                this.lead = {}
                this.loading = true
                Lead.get({id: changes.leadId.currentValue}).$promise
                    .then(lead => this.lead = lead)
                    .catch(() => this.lead = {})
                    .finally(() => this.loading = false)
            }
            this.showLead = () => LeadService.show(this.leadId)
            this.relationLabel = () => {
                if (!this.lead || !this.lead.referrerClient) {
                    return 'Polecający / pośrednik'
                }
                return this.lead.referrerType === 'INTERMEDIARY' ? 'Pośrednik' : 'Polecający'
            }
        }
    })
    .component('propertyDealBuyerInfo', {
        bindings: {
            buyer: '<',
            propertyDeal: '<'
        },
        template: `
            <div class="client-lead-card property-deal-buyer-card" ng-if="$ctrl.buyer">
                <div class="client-finder-card-actions" ng-if="$ctrl.propertyDeal">
                    <div class="btn-group btn-group-xs no-z-index-dropdown-over-fix" uib-dropdown uib-keyboard-nav auto-dropdown>
                        <button type="button" class="btn btn-options" uib-dropdown-toggle>
                            <i class="fa fa-ellipsis-v"></i><span class="sr-only" translate="global.options"></span>
                        </button>
                        <ul class="text-left dropdown-menu-right client-finder-options-menu no-z-index-dropdown-over-fix" uib-dropdown-menu>
                            <li>
                                <a href ng-click="$ctrl.editBuyers()"><i class="fa fa-fw fa-pencil"></i> Edycja</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="property-deal-buyer-card__name"
                     ng-class="{'property-deal-buyer-card__name--without-icon': !$ctrl.hasTypeIcon()}">
                    <span>{{$ctrl.displayName()}}</span>
                    <client-type-icon ng-if="$ctrl.hasTypeIcon()" type="$ctrl.buyerType()"></client-type-icon>
                    <span class="property-deal-entity-id"
                          ng-if="$ctrl.buyer.client && $ctrl.buyer.client.id"
                          uib-tooltip="Kontrahent">
                        #{{$ctrl.buyer.client.id}}
                    </span>
                </div>
                <div class="client-finder__contacts property-deal-buyer-card__contacts" ng-if="$ctrl.hasContactData()">
                    <div class="client-finder__contact" ng-if="$ctrl.buyer.phone1">
                        <phone-number-display value="$ctrl.buyer.phone1" subject-name="$ctrl.displayName()" show-options-menu="false"></phone-number-display>
                    </div>
                    <div class="client-finder__contact" ng-if="$ctrl.buyer.phone2">
                        <phone-number-display value="$ctrl.buyer.phone2" subject-name="$ctrl.displayName()" show-options-menu="false"></phone-number-display>
                    </div>
                    <div class="client-finder__contact" ng-if="$ctrl.buyer.email">
                        <email-display value="$ctrl.buyer.email"></email-display>
                    </div>
                </div>
                <div class="property-deal-buyer-card__details" ng-if="$ctrl.buyer.nip || $ctrl.addressText()">
                    <div class="property-deal-buyer-card__detail property-deal-buyer-card__detail--inline" ng-if="$ctrl.buyer.nip">
                        <span>NIP</span>
                        <strong>{{$ctrl.buyer.nip}}</strong>
                    </div>
                    <div class="property-deal-buyer-card__detail" ng-if="$ctrl.addressText()">
                        <strong>{{$ctrl.addressText()}}</strong>
                    </div>
                </div>
            </div>
        `,
        controller: function (PropertyDealService) {
            this.buyerType = () => this.buyer && (this.buyer.type || (this.buyer.client && this.buyer.client.type));
            this.hasTypeIcon = () => ['RETAIL', 'COMPANY'].indexOf(this.buyerType()) !== -1;
            this.displayName = () => this.buyer.fullName || (this.buyer.client && this.buyer.client.fullName) || 'Nabywca';
            this.hasContactData = () => !!(this.buyer.phone1 || this.buyer.phone2 || this.buyer.email);
            this.addressText = () => [this.buyer.address, [this.buyer.postcode, this.buyer.city].filter(Boolean).join(' ')]
                .filter(Boolean)
                .join(', ');
            this.editBuyers = () => PropertyDealService.buyersEdit(this.propertyDeal);
        }
    })
    .factory('PropertyDealBuyerMapper', function () {
        const contactValues = (client, type) => ((client && client.contacts) || [])
            .filter(contact => contact && contact.type === type && contact.value && contact.active !== false)
            .sort((a, b) => {
                if (a.defaults === true && b.defaults !== true) {
                    return -1;
                }
                if (b.defaults === true && a.defaults !== true) {
                    return 1;
                }
                return (a.id || 0) - (b.id || 0);
            })
            .map(contact => contact.value);

        const clientValue = (client, property, type, index) => {
            const contacts = contactValues(client, type);
            return client && client[property] ? client[property] : contacts[index] || null;
        };

        const mapClient = client => {
            if (!client) {
                return {};
            }

            const phone1 = clientValue(client, 'phone1', 'PHONE', 0);
            const phone2 = clientValue(client, 'phone2', 'PHONE', 1);
            const email = clientValue(client, 'email', 'EMAIL', 0);

            return {
                client: {
                    id: client.id || client.clientId,
                    fullName: client.fullName,
                    phone1: phone1,
                    phone2: phone2,
                    email: email,
                    type: client.type,
                    nip: client.nip,
                    address: client.address,
                    postcode: client.postcode,
                    city: client.city,
                    contacts: angular.copy(client.contacts || [])
                },
                fullName: client.fullName,
                phone1: phone1,
                phone2: phone2,
                email: email,
                type: client.type,
                nip: client.nip,
                address: client.address,
                postcode: client.postcode,
                city: client.city
            };
        };

        return {
            mapClient: mapClient,
            applyClient: (client, buyer) => angular.extend(buyer, mapClient(client))
        };
    })
    .service('PropertyDealService', function ($http, $rootScope, toastr, modals, PropertyDeal, PropertyService, Principal) {
            this.show = id => {
                return modals.open('app/property-deal/show-modal.html', 'PropertyDealShowModalController', {id: id}, {size: "lg"}, "$ctrl")
            }
            this.add = item => {
                let entity = {
                    id: null,
                    buyers: [],
                    items: []
                }
                angular.extend(entity, item)
                return modals.open('app/property-deal/create-modal.html', 'PropertyDealDialogController', entity, {size: "lg"}, "$ctrl")
            };
            this.lock = item => {
                let content = "<b>Czy na pewno chcesz zablokować rekord do zapisu?</b>";
                return modals.confirm(content, () => PropertyDeal.lock({id: item.id}, () => $rootScope.$broadcast('property-deal.updated')))
            }
            this.unlock = item => {
                let content = "Odblokowanie spowoduje umożliwienie operacji zapisu. Po zakończeniu należy ponownie zablokować rekord!<b>Czy na pewno chcesz odblokować?</b>";
                return modals.confirm(content, () => PropertyDeal.unlock({id: item.id}, () => $rootScope.$broadcast('property-deal.updated')))
            }
            this.descriptionEdit = item => {
                return modals.open('app/property-deal/description-modal.html', 'PropertyDealDescriptionController', item, {size: "sm"}, "$ctrl")
            }
            this.managerEdit = item => {
                return modals.open('app/property-deal/manager-modal.html', 'PropertyDealManagerController', item, {size: "sm"}, "$ctrl")
            }
            this.buyersEdit = item => {
                return modals.open('app/property-deal/_buyers-modal.html', 'PropertyDealBuyersController', item, {size: "lg"}, "$ctrl")
            }
            this.agreementsEdit = item => {
                return modals.open('app/property-deal/agreements-edit-modal.html', 'PropertyDealAgreementsEditController', angular.copy(item), {size: "md"}, "$ctrl")
            }
            this.addProperty = (projectId, dealId) => {
                return PropertyService.selectProperty(projectId, []).then(property => {
                    PropertyDeal.addItem({id: dealId, type: 'ASSET', propertyId: property.id}).$promise.then(() => $rootScope.$broadcast('property-deal.updated'))
                })
            }
            this.addExtraCharge = (projectId, dealId, propertyId) => {
                return modals.open('app/property-deal/_add-extra-charge-modal.html', 'PropertyDealAddExtraChargeController', {projectId: projectId, dealId: dealId, propertyId: propertyId}, {size: "lg"}, "$ctrl").then(result => {
                    PropertyDeal.addItem({id: dealId, propertyId, type: 'EXTRA_CHARGE', name: result.name, calculationMethod: result.calculationMethod, vat: result.vat, pricing: result.pricing})
                        .$promise.then(() => $rootScope.$broadcast('property-deal.updated'))
                })
            }
            this.removeItem = (propertyDealId, itemId) => {
                return modals.confirmDelete("wybrany rekord", () => PropertyDeal.removeItem({id: propertyDealId, itemId: itemId}).$promise.then(() => $rootScope.$broadcast('property-deal.updated')))
            }
            this.action = (id, status, action) => {
                PropertyDeal.get({id: id}).$promise.then(item => {
                    let form = {
                        item: item,
                        status: status,
                        action: action
                    }
                    return modals.open('app/property-deal/status-modal.html', 'PropertyDealStatusController', form, {size: "sm"}, "$ctrl")
                })
            }

            this.transferPropertyDeal = item => {
                let form = {
                    item: item,
                    status: 'TRANSFERRED',
                    action: 'transfer'
                }
                return modals.open('app/property-deal/status-modal.html', 'PropertyDealStatusTransferController', form, {size: "sm"}, "$ctrl")

            }
            this.delete = item => {
                return modals.confirmDelete("wybrany rekord", () => PropertyDeal.delete({id: item.id}, () => $rootScope.$broadcast('property-deal.updated')))
            };

            this.upload = (id, stage) => {
                let data = {
                    id: id,
                    stage: stage
                }
                return modals.open('app/property-deal/file-attach-modal.html', 'PropertyDealFileAttachController', data, {size: "sm"}, "$ctrl").then(() => $rootScope.$broadcast('property-deal.updated'))
            }

            this.removeFile = (id, stage) => {
                return modals.confirmDelete("wybrany załącznik", () => PropertyDeal.removeFile({id: id, action: stage}, () => $rootScope.$broadcast('property-deal.updated')))
            }

            this.changePrice = (item) => {
                // return modals.open('app/property-deal/_change-price-modal.html', 'PropertyDealItemChangePriceController', item, {size: "lg"}, "$ctrl")
                switch (item.type) {
                    case 'ASSET':
                        return modals.open('app/property-deal/_change-price-modal.html', 'PropertyDealAssetChangePriceController', item, {size: "lg"}, "$ctrl")
                    case 'EXTRA_CHARGE':
                        return modals.open('app/property-deal/_change-price-modal.html', 'PropertyDealExtraChargeChangePriceController', item, {size: "lg"}, "$ctrl")
                    default:
                        alert('UNKNOWN item type = ' + item.type);
                        break;
                }
            }

            this.leadLink = (leadId) => {
                return this.selectModal().then(propertyDeal => {
                    return PropertyDeal.leadLink({id: propertyDeal.id, leadId: leadId}).$promise.then(() => propertyDeal.id)
                })
            }

            this.leadUnlink = (leadId, propertyDealId) => {
                return modals.confirm("Czy na pewno chcesz odłączyć?", () => {
                    return PropertyDeal.leadUnlink({id: propertyDealId, leadId: leadId}).$promise
                })
            }

            this.selectModal = () => {
                return modals.open('app/property-deal/select-modal.html', 'PropertyDealSelectController', {withLead: false}, {size: "lg"}, "$ctrl");
            }

            this.changeBankAccount = form => {
                return modals.open('app/property-deal/_bank-account-modal.html', 'PropertyDealBankAccountController', form, {size: "md"}, "$ctrl")
            }

            this.changeLivingAreaFinal = form => {
                return modals.open('app/property-deal/_living-area-final-modal.html', 'PropertyDealLivingAreaFinalController', form, {size: "sm"}, "$ctrl")
            }
            this.statusToggleForManager = item => {
                return modals.open('app/property-deal/status-toggle-modal.html', 'PropertyDealStatusToggleController', angular.copy(item), {size: "sm"}, "$ctrl")
            }
            this.statisticsToggle = item => {
                let excludeFromStatistics = !item.excludeFromStatistics
                let message = excludeFromStatistics
                    ? "<b>Czy na pewno chcesz usunąć rekord ze statystyk?</b>"
                    : "<b>Czy na pewno chcesz przywrócić rekord do statystyk?</b>"

                return modals.confirm(message, () => {
                    return PropertyDeal.statisticsUpdate({id: item.id, excludeFromStatistics: excludeFromStatistics}).$promise
                        .then(() => $rootScope.$broadcast('property-deal.updated'))
                })
            }
            this.saleReport = () => {
                return modals.open('app/property-deal/sale-report-modal.html', 'PropertyDealSaleReportController', {}, {size: "sm"}, "$ctrl")
            }
            this.financingUpdate = (id, financing) => {
                return modals.open('app/property-deal/financing-modal.html', 'PropertyDealFinancingUpdateController', {id: id, financing: financing}, {size: "sm"}, "$ctrl")
            }
            this.financingUpdateSave = (id, financing) => {
                return PropertyDeal.financingUpdate({id: id, financing: financing}).$promise.then(() => $rootScope.$broadcast('property-deal.updated'))
            }
        }
    )
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_PROPERTY_DEAL",
            path: "/property-deal",
            ico: 'fa fa-home fa-fw',
            name: 'property-deal.menu',
            order: 33
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('propertyDealList', {
            parent: 'app',
            url: '/property-deal?{page:int}&{size:int}&sort&search&status&agreementType&notAgreementType&project&manager&referrerClient&periodStart&periodEnd&acquisitionStart&acquisitionEnd&customFilter&techTypes&financing',
            data: {
                authorities: ['ROLE_PROPERTY_DEAL']
            },
            params: {
                status: {array: true, value: ['PRE_BOOKING', 'BOOKED'], squash: false},
                agreementType: {array: true},
                notAgreementType: {array: true},
                techTypes: {array: true},
                project: { array: true, type: "int" },
                manager: {type: 'int'},
                referrerClient: {type: 'int'},
            },
            views: {
                'content@': 'propertyDealList'
            },
            resolve: {
                statistics: (PropertyDeal, $stateParams) => PropertyDeal.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (PropertyDeal, $stateParams) => PropertyDeal.table(angular.copy($stateParams)).$promise
            }
        });
        $stateProvider.state('propertyDealShow', {
            parent: 'app',
            url: '/property-deal/{id}',
            data: {
                authorities: ['ROLE_PROPERTY_DEAL']
            },
            views: {
                'content@': {
                    templateUrl: 'app/property-deal/show.html',
                    controller: 'PropertyDealShowController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                item: (PropertyDeal, $stateParams) => PropertyDeal.get({id: $stateParams.id}).$promise
            }
        });
    })
